<div class="relative shrink-0">
  @if (expanded() && !first()) {
    <!-- 上分割线：在手风琴打开时，占位于该任务条目上方（列表首个任务上方无内容，不展示） -->
    <nz-divider nzSize="small"></nz-divider>
  }
  <!-- 任务条目标题 -->
  <div
    class="relative flex items-center gap-[12px] p-2 rounded-[6px] cursor-pointer transition-colors hover:bg-neutral-n7"
    [class.bg-primary-b7]="expanded()"
    (click)="toggle.emit()"
  >
    <!-- 类型图标（白底+彩色描边，右上角未读角标） -->
    <nz-badge [nzCount]="thread.unReadCount" [nzShowZero]="false" [nzOffset]="[-8, 2]">
      <div
        class="relative shrink-0 size-[32px] rounded-full flex items-center justify-center text-[11px] font-medium border"
        [class]="(thread.type | messageType).colorClass"
      >
        {{ (thread.type | messageType).label }}
      </div>
    </nz-badge>

    <!-- 标题 + 班级名 + 最后一条消息摘要 -->
    <div class="flex-1 min-w-0">
      <div class="flex items-center justify-between gap-[4px] text-[14px] leading-[1.4]">
        <span class="font-medium truncate">{{ thread.title }}</span>
        @if (thread.classroomName) {
          <span class="shrink-0 text-neutral-n3 text-[12px]">{{ thread.classroomName | classNameTail }}</span>
        }
      </div>
      <div class="text-[13px] leading-[20px] mt-1/2 truncate text-neutral-n3">
        <fl-message-summary [summary]="thread.lastMessage"></fl-message-summary>
      </div>
    </div>
  </div>

  <!-- 展开区：题号反馈列表（statis 就绪后才渲染并触发展开动画，避免首次加载动画与内容不同步） -->
  @if (expanded() && statisLoaded) {
    <div
      @expandCollapse
      (@expandCollapse.done)="onExpandDone()"
      class="space-y-[8px] mt-2 max-h-[476px] overflow-y-auto"
    >
      @for (item of statis; track item.id) {
        @let kind = item | messageItemKind;
        <div
          [attr.data-item-id]="item.id"
          class="relative flex items-center rounded border-[0.5px] px-[12px] py-[10px] cursor-pointer transition-colors"
          [ngClass]="
            item.id === activeItemId
              ? 'border-primary-b6 bg-primary-b7'
              : 'border-neutral-n5 bg-white hover:bg-neutral-n7'
          "
          (click)="selectQuestion.emit(item.id)"
        >
          <!-- 左侧：题号 / 模块名称 / 任务反馈（含未读红点） -->
          <div
            class="relative shrink-0 mr-[8px] text-[12px] text-neutral-n1"
            [ngClass]="kind === 'module' ? 'max-w-[240px] truncate' : 'w-[40px]'"
          >
            {{ kind === 'question' ? item.no : kind === 'module' ? (item.moduleName | messageModuleName) : '任务反馈' }}
            @if (item.unReadCount > 0) {
              <i class="absolute -top-[3px] -left-[6px] h-[6px] w-[6px] rounded-[50%] bg-red-r3"></i>
            }
          </div>
          <!-- 行尾：类型角标在左，得分率最右（固定宽度避免各题错位） -->
          <div class="ml-auto shrink-0 flex items-center gap-[8px]">
            @for (type of item.typeStatis | messageTypeOrder; track type.typeId) {
              <span
                nz-tooltip
                [nzTooltipTitle]="type.typeName"
                class="flex h-[20px] min-w-[20px] items-center justify-center gap-[3px] text-[12px] leading-none text-neutral-n2"
              >
                <lib-fl-icon [name]="type.typeName | emjioIconName" [isMultiColor]="true" size="14px"></lib-fl-icon>
                {{ type.count }}
              </span>
            }
            <!-- 得分率仅题目类型显示；任务/模块反馈不展示 -->
            @if (kind === 'question') {
              <div class="shrink-0 w-[35px] text-right text-[12px] text-neutral-n3">
                <span [style.color]="item.correctPercent | evaluateColor">{{
                  item.correctPercent | percentFixed
                }}</span>
              </div>
            }
          </div>
        </div>
      } @empty {
        <div class="h-[32px] flex items-center justify-center text-neutral-n4">暂无题号</div>
      }
    </div>
    <nz-divider nzSize="small"></nz-divider>
  }
</div>
